export function NULL_FUNCTION() { return null; }

/**
 * Returns a debounced version of the given function with
 * the provided buffer time.
 *
 * @param callback {Function}
 * @param buffer {Number}
 * @returns {Function}
 */
export function debounce(callback: Function, buffer: number, context: object = globalThis || window) {
	let timeout;
	return function () {
		const args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(() => callback.apply(context, args), buffer);
	};
}

/**
 * Returns a throttled version of the given function with
 * the provided buffer time.
 *
 * @param callback {Function}
 * @param buffer {Number}
 * @returns {Function}
 */
export function throttle(callback: Function, interval: number, context: object = globalThis || window) {
	let wait = false;
	return function () {
		if (!wait) {
			const args = arguments;
			callback.apply(context, args);
			wait = true;
			setTimeout(() => wait = false, interval);
		}
	}
}

export function random(min: number, max: number, integer: boolean = true) {
	const rnd = Math.random() * (max - min) + min;
	return integer ? Math.floor(rnd) : rnd;
}

export function hashString(value: string) {
	let hash = 0, i, chr;
	if (value.length === 0) return hash;
	for (i = 0; i < value.length; i++) {
		chr = value.charCodeAt(i);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
}

export function documentContains(node) {
	if (document.contains)
		return document.contains(node);
	if (document.body && document.body.contains)
		return document.body.contains(node);
	return false;
}